var collapsible_list_pair_default = {
  "container": "J1Op7",
  "title": "lLdHg",
  "viewerContainer": "jWjXA",
  "titleContainer": "Jhd9A",
  "expandIcon": "rAmPg",
  "dndIcon": "l3awI",
  "RTL": "rku0G",
  "LTR": "jenwU",
  "itemContainer": "_0tyVS",
  "itemContainerViewer": "ZA-Qc",
  "mouseDown": "jcXO4",
  "innerEditor": "crVye",
  "item": "WeWiR",
  "floatingAddPluginMenuWrapper": "XKSLn",
  "childrenHidden": "z0qOs"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
